import vet1 from "../images/vet2/백성현.png";
import vet2 from "../images/vet2/김보미.png";
import vet3 from "../images/vet2/강아란.png";
import vet4 from "../images/vet2/민현아.png";
import vet5 from "../images/vet2/윤종현.png";
import vet6 from "../images/vet2/최예슬.png";
import vet7 from "../images/vet2/이은지.png";
import vet8 from "../images/vet2/설상우.png";
import vet9 from "../images/vet2/민경대.png";
import vet10 from "../images/vet2/이가은.png";
import vet11 from "../images/vet2/김은호.png";
import vet12 from "../images/vet2/안종무.png";
import vet13 from "../images/vet2/윤영호.png";
import vet14 from "../images/vet2/김범준.png";
import vet15 from "../images/vet2/심예윤.png";
import vet16 from "../images/vet2/이영주.png";
import vet17 from "../images/vet2/최민영.png";
import vet18 from "../images/vet2/윤승현.png";
import vet19 from "../images/vet2/이송하.png";
import vet20 from "../images/vet2/이상규.png";
import vet21 from "../images/vet2/박진형.png";
import vet22 from "../images/vet2/강형욱.png";
import vet23 from "../images/vet2/김영준.png";
import vet24 from "../images/vet2/임대웅.png";
import vet25 from "../images/vet2/이인선.png";
import vet26 from "../images/vet2/김영서.png";
import vet27 from "../images/vet2/김정민.png";

import tvet1 from "../images/vet/백성현.png";
import tvet2 from "../images/vet/김보미.png";
import tvet3 from "../images/vet/강아란.png";
import tvet4 from "../images/vet/민현아.png";
import tvet5 from "../images/vet/윤종현.png";
import tvet6 from "../images/vet/최예슬.png";
import tvet7 from "../images/vet/이은지.png";
import tvet8 from "../images/vet/설상우.png";
import tvet9 from "../images/vet/민경대.png";
import tvet10 from "../images/vet/이가은.png";
import tvet11 from "../images/vet/김은호.png";
import tvet12 from "../images/vet/안종무.png";
import tvet13 from "../images/vet/윤영호.png";
import tvet14 from "../images/vet/김범준.png";
import tvet15 from "../images/vet/심예윤.png";
import tvet16 from "../images/vet/이영주.png";
import tvet17 from "../images/vet/최민영.png";
import tvet18 from "../images/vet/윤승현.png";
import tvet19 from "../images/vet/이송하.png";
import tvet20 from "../images/vet/이상규.png";
import tvet21 from "../images/vet/박진형.png";
import tvet22 from "../images/vet/강형욱.png";
import tvet23 from "../images/vet/김영준.png";
import tvet24 from "../images/vet/임대웅.png";
import tvet25 from "../images/vet/이인선.png";
import tvet26 from "../images/vet/김영서.png";
import tvet27 from "../images/vet/김정민.png";

const vetInfo = [
  {
    id: 1,
    position: "대표원장",
    name: "백성현",
    img: vet1,
    timg: tvet1,
    title: "전남대학교 수의과대학 졸업",
    greetings:
      "치료는 아픈 아이들의 마음을 이해하는 것부터 시작입니다. 보호자님들과 아이들이 함께하는 시간의 시작과 끝을 책임지겠습니다.",
    history: [
      "전남대학교 수의내과학실 석사과정",
      "전 목포시 유기동물보호소 관리담당 수의사",
      "전)부천24시스카이동물병원 진료수의사",
      "전)인천24시스카이동물의료센터 진료수의사",
      "전)인천24시스카이동물의료센터 진료부장",
      "전)인천24시스카이동물의료센터 부원장",
      "전)서울강동24시스카이동물의료센터 원장",
      "현)광주24시스카이동물메디컬센터 원장",
      "한국동물병원협회 이사",
      "한국고양이수의사회(KSFM) 정회원",
      "한국종양의학연구회 정회원",
      "한국동물매개심리치료학회 동물행동상담사",
      "반려동물토탈케어 펫닥 진료 자문수의사",
      "2018 Life&Dogue 닥터스페셜 분야별 최고수의사 12인 선정 및 치과자문수의사",
      "2018 서울시 강동구반려동물사랑축제 진료자문수의사",
      "2017-18 대웅제약 줄기세포투여 관절재생 외부협력병원장",
      "2023 대웅재단 신진의과학자 해외학회중계원",
      "ACVIM FORUM 2023 Philadelphia,Pennsylvenia",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 2,
    position: "대표원장",
    name: "김보미",
    img: vet2,
    timg: tvet2,
    title: "제주대학교 수의과대학 졸업",
    greetings: "모든 동물들이 건강하고 행복하도록 최선을 다하겠습니다.",
    history: [
      "경희대학교 유전공학과 졸업",
      "GIST bio-remodeling & gene therapy lab. 오픈랩 수료",
      "제주대학교 수의과대학 졸업",
      "충남대학교 수의외과학실 석사과정",
      "제주 WSAVA(세계소동물수의사대회) 참가",
      "서울 수의임상컨퍼런스 참가",
      "수의 응급외과 세미나 수료",
      "한국 수의 순환기학회 세미나 수료",
      "임상 수의 안과 세미나 수료",
      "부천24시스카이동물병원 인턴십 수료",
      "전)부천24시스카이동물병원 진료수의사",
      "전)부천24시스카이동물병원 부원장",
      "현)광주24시스카이동물메디컬센터 원장",
      "한국수의외과학회 정회원",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 3,
    position: "외과과장",
    name: "강아란",
    img: vet3,
    timg: tvet3,
    title: "충남대학교 수의과대학 수의학과 졸업",
    greetings: "반려동물과 함께하는 가족의 행복을 위해 늘 함께 하겠습니다.",
    history: [
      "고려대학교 생체의공학과 졸업",
      "고려대학교 KU-KIST 융합대학원 석사 졸업",
      "충남대학교 수의과대학 수의학과 졸업",
      "충남대학교 수의과대학 임상수의학 석사 졸업 (수의외과학)",
      "충남대학교 수의과대학 부속동물병원 외과 수련의",
      "충남대학교 수의과대학 부속동물병원 인턴장",
      "충남대학교 수의과대학 수의외과학교실 실습 조교",
      "현)광주24시스카이동물메디컬센터 외과과장",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 4,
    position: "외과과장",
    name: "민현아",
    img: vet4,
    timg: tvet4,
    title: "충남대학교 수의외과학 석사 졸업",
    greetings:
      "근거 중심의 정확한 지식을 바탕으로 진정성 있는 수의사가 되도록 최선을 다하겠습니다.",
    history: [
      "충남대학교 수의과대학 졸업",
      "충남대학교 수의외과학 석사 졸업",
      "2019-2020 천안 나우동물의료센터 진료 수의사",
      "2020-2022 충남대학교 부속동물병원 외과 진료 수의사",
      "2023-2024 24시 예담동물의료센터 외과 과장",
      "현) 광주SKY동물메디컬센터 외과 과장",
    ],
    paper: [
      "2021 임상수의학회 추계학술대회 증례발표 Bougienage Treatment of Severe Dilation of Total Biliary Tract with Common Bile Duct Stricture in a Dog",
      "2022 J Vet Clin 논문 게재 Cadaveric Feasibility Study of Knotless Barbed Suture for Tracheal Anastomosis in Dogs",
    ],
    completion: ["수의외과학회 정회원"],
  },
  {
    id: 5,
    position: "진료과장",
    name: "윤종현",
    img: vet5,
    timg: tvet5,
    title: "전남대학교 수의과대학 졸업",
    greetings:
      "아이들을 제 가족처럼 소중히 여기며 감동과 희망을 전하는 수의사가 되겠습니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "전남대학교 수의생리학교실",
      "대구광역시 공중방역수의사",
      "33rd World Veterinay Congress",
      "전)광주24시스카이동물메디컬센터 진료수의사",
      "현)광주24시스카이동물메디컬센터 진료과장",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 6,
    position: "내과과장",
    name: "최예슬",
    img: vet6,
    timg: tvet6,
    title: "전북대학교 수의학과 졸업",
    greetings: "다정한 손길로, 숨은 질환도 꼼꼼하게 찾아내도록 하겠습니다.",
    history: [
      "전북대학교 수의학과 졸업",
      "해운대동물 메디컬센터 진료수의사",
      "전)전북대학교 내과 전공수의사",
      "현)광주24시스카이동물메디컬센터 내과과장",
      "한국임상수의학 춘계 학술대회 참가 (2023. 04)",
      "2023 ACVIM Forum, Philadelphia, Pennsylvania 참가 (2023.6)",
      "한국임상수의학 추계 학술대회 ‘Association Atrial Fibrillation in dog with Myxomatous",
      "Mitral Valve Disease and Optimal Rate Control’ 발표 (2023. 10)",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 21,
    position: "내과과장",
    name: "박진형",
    img: vet21,
    timg: tvet21,
    title: "전남대학교 수의과대학 졸업",
    greetings: "따뜻한 마음과 전문성으로 함께하겠습니다.",
    history: [
      "전남대학교 수의학과 졸업",
      "전) 충북대학교 내과 전공수의사",
      "현) 광주24시스카이동물메디컬센터 내과과장",
      "2022 ACVIM Forum, Austin, Texas 참가 (2022. 6)",
      "대한수의학회 추계 학술대회 참가 (2022. 11)",
      "한국임상수의학 춘계 학술대회 'Evaluation of remnant and metastatic lesions in a cat with alimentary lymphoma using 18F-fluorodeoxyglucose positron emission tomography' 발표 (2023. 5)",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 7,
    position: "영상과장",
    name: "이은지",
    img: vet7,
    timg: tvet7,
    title: "전남대학교 수의과대학 영상의학과 석사 졸업",
    greetings: "언제나 믿고 의지할 수 있는 평생 주치의가 되겠습니다.",
    history: [
      "전남대학교 수의과대학 학사 졸업",
      "전남대학교 수의과대학 영상의학과 석사 졸업",
      "현)광주24시스카이동물메디컬센터 영상과장",
      '2019 춘계 한국수의임상학회 포스터 발표 "CT Vaginographic Features of Atresia Ani Type II and Rectovestibular Fistula in a Dog"',
      '2020 추계 한국임상수의학회 연제 발표 "3.0 Tesla Magnetic Resonance Imaging of Canine Adrenal Gland"',
    ],
    paper: [
      "Radiography and ct features of atherosclerosis in two miniature schnauzer dogs. Journal of Veterinary Science, 2020, 21.6.",
      "3.0-Tesla MRI of normal canine adrenal glands. Veterinary Radiology & Ultrasound, 2022 Mar;63(2):206-215.",
    ],
    completion: [],
  },
  {
    id: 8,
    position: "진료수의사",
    name: "설상우",
    img: vet8,
    timg: tvet8,
    title: "전남대학교 수의과대학 졸업",
    greetings:
      "모든 환자들은 특별하고 소중합니다. 아이들의 건강을 위해 헌신하겠습니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "한국 고양이수의사회 정회원",
      "전)전주메이동물병원 진료수의사",
      "전)광주블루밍동물병원 진료수의사",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  // {
  //   id: 9,
  //   position: "진료수의사",
  //   name: "민경대",
  //   img: vet9,
  //   timg: tvet9,
  //   title: "강원대학교 수의과대학 수의학과 졸업",
  //   greetings: "보호자님의 마음까지 공감할 수 있는 수의사가 되겠습니다.",
  //   history: [
  //     "강원대학교 수의과대학 수의학과 졸업",
  //     "고창군청 공중방역수의사",
  //     "전북도청 동물위생시험소 수의사",
  //     "현)광주24시스카이동물메디컬센터진료 수의사",
  //   ],
  //   paper: [],
  //   completion: [],
  // },
  {
    id: 10,
    position: "진료수의사",
    name: "이가은",
    img: vet10,
    timg: tvet10,
    title: "전남대학교 수의과대학 졸업",
    greetings: "아이들을 사랑하는 수의사, 따뜻한 손길로 치료하겠습니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "한국 고양이수의사회 정회원",
      "전)전주메이동물병원 진료수의사",
      "전)광주블루밍동물병원 진료수의사",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  // {
  //   id: 11,
  //   position: "진료수의사",
  //   name: "김은호",
  //   img: vet11,
  //   timg: tvet11,
  //   title: "전남대학교 수의과대학 졸업",
  //   greetings:
  //     "환자와 보호자님의 입장에서 생각하고 최선을 다해 진료하겠습니다.",
  //   history: [
  //     "전남대학교 수의과대학 졸업",
  //     "현)광주24시스카이동물메디컬센터 진료수의사",
  //   ],
  //   paper: [],
  //   completion: [],
  // },
  // {
  //   id: 12,
  //   position: "진료수의사",
  //   name: "안종무",
  //   img: vet12,
  //   timg: tvet12,
  //   title: "경상대학교 수의과대학 졸업",
  //   greetings:
  //     "저와 만난 모든 아이들과 보호자님이 언제나 건강하고 행복하길 바라겠습니다.",
  //   history: [
  //     "경상대학교 수의과대학 졸업",
  //     "현)광주24시스카이동물메디컬센터 진료수의사",
  //   ],
  //   paper: [],
  //   completion: [],
  // },
  {
    id: 13,
    position: "진료수의사",
    name: "윤영호",
    img: vet13,
    timg: tvet13,
    title: "전북대학교 수의과대학 학사 졸업",
    greetings: "환자와 보호자님의 마음까지 치료하는 수의사가 되겠습니다.",
    history: [
      "전북대학교 수의과대학 학사 졸업",
      "전국수의학도협의회 대외협력국 부국장",
      "전북대학교 수의과대학 clinical rotation 수료",
      "서울대학교 수의과대학 clinical rotation 기본 수료",
      "서울대학교 수의과대학 clinical rotation 심화 수료",
      "서울 수의 임상 컨퍼런스 참가 (2018)",
      "아시아 수의치과 포럼 참가 및 수료 (2023)",
      "대한수의사회(KVMA) 정회원",
      "한국수의치과협회 (KVDS) 정회원",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 14,
    position: "진료수의사",
    name: "김범준",
    img: vet14,
    timg: tvet14,
    title: "전남대학교 수의과대학 졸업",
    greetings: "환자와 보호자님의 삶에 행복을 드릴 수 있도록 헌신하겠습니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "전남대학교 수의내과학교실",
      "장흥군청 공중방역수의사",
      "화순군청 공중방역수의사",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 15,
    position: "진료수의사",
    name: "심예윤",
    img: vet15,
    timg: tvet15,
    title: "전남대학교 수의과대학 졸업",
    greetings:
      "사랑과 이해를 바탕으로 환자와 보호자님을 돌보는 수의사로서, 항상 함께하겠습니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "전남대학교 외과학교실 학부과정 수료",
      "전남대학교 내과학교실 실습 수료",
      "경상대학교 영상의학교실 실습 수료",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 16,
    position: "진료수의사",
    name: "이영주",
    img: vet16,
    timg: tvet16,
    title: "전남대학교 수의과대학 졸업",
    greetings: "반려동물과 보호자님을 위해 최선을 다하는 수의사입니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "현)광주24시스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 17,
    position: "진료수의사",
    name: "최민영",
    img: vet17,
    timg: tvet17,
    title: "전남대학교 수의과대학 졸업",
    greetings:
      "소중한 가족인 환자와 보호자님의 행복을 위해 노력하는 수의사입니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "전남대학교 내과학교실 학부과정 수료",
      "현)광주24시스카이동물메디컬센터 진료수의사",
      "2017 World Veterinary Congress 참가",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 18,
    position: "응급의학과장",
    name: "윤승현",
    img: vet18,
    timg: tvet18,
    title: "전남대학교 수의과대학 졸업",
    greetings: "책임감 있는 치료로 환자와 보호자님의 소중한 시간을 지킵니다.",
    history: [
      "전남대학교 수의과대학 졸업",
      "전)구미jm동물메디컬센터 진료수의사",
      "전)광주24시스카이동물메디컬센터 진료수의사",
      "현)광주24시스카이동물메디컬센터 야간응급수의사",
    ],
    paper: [],
    completion: [],
  },
  // {
  //   id: 19,
  //   position: "진료수의사",
  //   name: "이송하",
  //   img: vet19,
  //   timg: tvet19,
  //   title: "전남대학교 수의과대학 졸업",
  //   greetings: "환자와 보호자님의 미소와 건강을 위해 최선을 다하겠습니다.",
  //   history: [
  //     "전남대학교 수의과대학 졸업",
  //     "웨스턴동물의료센터 수련의과정수료",
  //     "웨스턴동물의료센터 내과수의사",
  //     "웨스턴동물의료센터 입원실수의사",
  //     "현)광주24시스카이동물메디컬센터 야간응급수의사",
  //   ],
  //   paper: [],
  //   completion: [],
  // },
  // {
  //   id: 20,
  //   position: "진료수의사",
  //   name: "이상규",
  //   img: vet20,
  //   timg: tvet20,
  //   title: "전북대학교 수의과대학 수의학과 졸업",
  //   greetings: "환자와 보호자님의 미소가 우리의 보람입니다.",
  //   history: [
  //     "전북대학교 수의과대학 수의학과 졸업",
  //     "전북대학교 생화학 실험실",
  //     "서울대학교 평창연수원 농장동물교육 수료",
  //     "전북대학교 임상로테이션 수료",
  //     "전라북도 동물위생시험소 공중방역수의사",
  //   ],
  //   paper: [],
  //   completion: [],
  // },
  {
    id: 22,
    position: "진료수의사",
    name: "강형욱",
    img: vet22,
    timg: tvet22,
    title: "건국대학교 수의과대학 수의학과 졸업",
    greetings: "반려동물과 보호자가 함께 행복한 삶을 살 수 있도록 노력하겠습니다.",
    history: [
      "건국대학교 수의과대학 수의학과 졸업",
      "육군 수의사관 대위 전역",
      "전) 신사 24시 페츠비동물병원 진료수의사",
      "전) 석촌 이룸동물병원 진료수의사",
      "전) 농림축산검역본부 동물보호과 동물복지 담당",
      "영국 에딘버러 수의과대학 응용 동물행동 및 동물복지학 석사 취득",
      "영국 에딘버러 수의과대학 동물질병에 따른 행동변화 연구 박사 과정 중",
      "현) 광주스카이동물메디컬센터 야간 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 23,
    position: "진료수의사",
    name: "김영준",
    img: vet23,
    timg: tvet23,
    title: "전남대학교 수의과대학 수의학과 졸업",
    greetings: "반려동물이 아플 때 가장 따뜻한 손길이 되겠습니다.",
    history: [
      "전남대학교 수의과대학 수의학과 졸업",
      "전남대학교 수의내과학교실 학부과정",
      "전)검역본부 공중방역수의사",
      "현)광주스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 24,
    position: "진료수의사",
    name: "임대웅",
    img: vet24,
    timg: tvet24,
    title: "전남대학교 수의과대학 수의학과 졸업",
    greetings: "고통받는 동물을 위해 따뜻한 마음과 손길을 전하겠습니다.",
    history: [
      "전남대학교 수의과대학 수의학과 졸업",
      "전)함평군청 공중방역수의사",
      "전)광주동물위생시험소 수의사",
      "현)광주스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 25,
    position: "진료수의사",
    name: "이인선",
    img: vet25,
    timg: tvet25,
    title: "제주대학교 수의과대학 수의학과 졸업",
    greetings: "항상 겸손한 자세로 보호자와 소통하며 함께하겠습니다.",
    history: [
      "제주대학교 수의과대학 수의학과 졸업",
      "현)광주스카이동물메디컬센터 진료수의사",
      "수의골관절학회",
      "Dynamic Compression",
      "Plating mini course 수료",
      "AO VET Course Principles",
      "in Small Animal Fracture",
      "Management 수료",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 26,
    position: "진료수의사",
    name: "김영서",
    img: vet26,
    timg: tvet26,
    title: "전북대학교 수의과대학 수의학과 졸업",
    greetings: "언제나 최선의 치료와 세심한 진료를 약속드립니다.",
    history: [
      "강원대학교 수의과대학 수의학과 졸업",
      "강원대학교 야생동물질병학 실험실",
      "전) 농림축산검역본부 공중방역수의사",
      "전) 원주스카이동물메디컬센터 진료수의사",
      "현) 광주스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
  {
    id: 27,
    position: "진료수의사",
    name: "김정민",
    img: vet27,
    timg: tvet27,
    title: "전북대학교 수의과대학 수의학과 졸업",
    greetings: "소중한 반려동물의 생명을 최우선으로 생각하겠습니다.",
    history: [
      "전북대학교 수의과대학 수의학과 졸업",
      "전)전라북도 동물위생시험소 공중방역수의사",
      "전)전주메이동물병원 진료수의사",
      "현)광주스카이동물메디컬센터 진료수의사",
    ],
    paper: [],
    completion: [],
  },
];

export default vetInfo;
